import { DataroomTenant } from './DataroomTenant';

export interface IDataroomTenantContext {
  tenant: DataroomTenant,
}

// DI key of the tenant context value. Kept out of the 'use client' context module, so that
// server components are able to bind it into the server container as well.
export const DataroomTenantContextSymbol = Symbol('DataroomTenantContext');
